<script setup lang="ts">
import slugify from '@/lib/slugify';
import ConnxIcon from '@/components/Atoms/ConnxIcon.vue';
interface Props {
  title: string;
  labels: string[];
  goodContrast: boolean;
}

const emit = defineEmits(['show-bad-contrast-modal']);

defineProps<Props>();

</script>

<template>
  <section class="tw-mb-10">
    <h5 class="tw-mb-6">{{ title }}</h5>

    <div class="tw-flex tw-flex-wrap tw-flex-col-reverse md:tw-flex-row tw-items-start">
      <div class="tw-px-8 tw-w-full md:tw-w-4/12">
        <div v-for="(label, index) in labels" :key="label"
          class="tw-flex tw-flex-wrap tw-items-center tw-w-full tw-mb-6">
          <div class="tw-w-full md:tw-w-6/12 tw-pr-4">
            <label :for="slugify(label)" class="tw-mb-2 md:tw-mb-0">{{ label }}</label>
          </div>
          <div class="tw-w-full md:tw-w-6/12 tw-flex">
            <slot :name="`input-${index + 1}`" />
          </div>
        </div>
        <button type="button" v-show="!goodContrast"
          class="tw-border-none tw-outline-none tw-w-full md:tw-w-6/12 tw-ml-auto tw-flex tw-items-center tw-gap-x-2"
          @click="emit('show-bad-contrast-modal')" title="Click to view more information.">
          <div class="tw-text-connx-warning tw-flex tw-w-6 tw-h-6 tw-justify-center tw-items-center tw-rounded-full">
            <connx-icon name="fas fa-exclamation-triangle" class="tw-w-6 !tw-h-6"></connx-icon>
          </div>
          Poor Contrast
        </button>

      </div>
      <div class="tw-w-full md:tw-w-8/12 tw-bg-connx-grey-tint-80 tw-mb-10 tw-rounded-lg tw-overflow-hidden ScrollBar">
        <div class="tw-pt-8 tw-pb-5">
          <slot name="preview">Preview</slot>
        </div>
      </div>
    </div>
  </section>
</template>